import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F189DB12-9323-47A1-89C9-451EF2A886CB
 * name reorder-vertical
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/reorder-vertical.svg
 * tags
 */
export const ReorderVerticalIcon = createSvgIcon(<><path d="M9,3V21H11V3H9M5,3V21H7V3H5M13,3V21H15V3H13M19,3H17V21H19V3Z" /></>, 'ReorderVerticalIcon');
export default ReorderVerticalIcon